import { isAxiosError } from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  BulkImportFilesParams,
  BulkImportFilesResponse,
} from '@/features/bulkImportsHistory/types/bulkImportsHistory.types';
import { setResponseErrorStatus } from '@/features/session/store/sessionSlice';

import {
  getBulkImportFileReport,
  getBulkImportFilesList,
} from '../api/bulkImportsHistory.api';

export const getBulkImportFiles = createAsyncThunk<
  BulkImportFilesResponse,
  BulkImportFilesParams | undefined,
  { rejectValue: string }
>('bulkImportsHistory/getBulkImportFiles', async (params, thunkAPI) => {
  try {
    const defaultParams: BulkImportFilesParams = {
      page: 1,
      size: 10,
    };

    return await getBulkImportFilesList({
      ...defaultParams,
      ...(params ?? {}),
    });
  } catch (e) {
    if (isAxiosError(e)) {
      const status = e.response?.status;
      if (status === 401 || status === 403 || status === 404) {
        thunkAPI.dispatch(setResponseErrorStatus(status));
      }
    }

    return thunkAPI.rejectWithValue('Failed to fetch bulk import files');
  }
});

export const downloadBulkImportFileReport = createAsyncThunk<
  string,
  { fileId: number },
  { rejectValue: string }
>(
  'bulkImportsHistory/downloadBulkImportFileReport',
  async ({ fileId }, thunkAPI) => {
    try {
      return await getBulkImportFileReport(fileId);
    } catch (e) {
      if (isAxiosError(e)) {
        const status = e.response?.status;
        if (status === 401 || status === 403 || status === 404) {
          thunkAPI.dispatch(setResponseErrorStatus(status));
        }
      }

      return thunkAPI.rejectWithValue('Failed to download bulk import report');
    }
  }
);
